export const CPR_CONTROL = "cprNumber";
export const SHOULD_REMEMBER_USER_CONTROL = "shouldRememberUser";
export const loginErrorPrefix = "login.error.";

export const DGA_REGISTER_DIALOG_ID = "dga-register-flow-dialog";

export const COMMON_POKER_INCLIENT_RETURN_URL = "/common-poker-inclient/login";
export const OIDC_POKER_INCLIENT_RETURN_URL = "/poker-inclient/login";
